import GlobalTypes from './global.types';
import UserTypes from '../user/user.types';
import CallTypes from '../call/call.types';
import AppTypes from '../app/app.types';
import GlobalState from './global.state';
import AnyAction from 'store/anyActions';

const defaultState: GlobalState = {
    numberDialling: '',
    changingState: '',
    error: null,
    success: null,
    softphoneError: null,
    showIframe: false,
    online: true,
    redirect: null,
    showNotification: null,
};

export default function(state: GlobalState = defaultState, action: AnyAction) : GlobalState {
    switch (action.type) {
        case GlobalTypes.ADD_ERROR:
            return { ...state, error: action.payload };
        case GlobalTypes.ADD_SUCCESS:
            return { ...state, success: action.payload };
        case GlobalTypes.INTERNET_CONNECTION:
            return { ...state, online: action.payload };
        case GlobalTypes.ADD_SOFTPHONE_ERROR:
            return { ...state, softphoneError: action.payload}
        case GlobalTypes.CLEAR_SOFTPHONE_ERROR:
            return { ...state, softphoneError: null}
        case GlobalTypes.CLEAR_ERROR:
            return { ...state, error: null };
        case GlobalTypes.CLEAR_SUCCESS:
            return { ...state, success: null };
        case GlobalTypes.SHOW_NOTIFICATION:
            return { ...state, showNotification: { ...action.payload } }
        case GlobalTypes.DO_REDIRECT:
            return { ...state, redirect: action.payload }
        case GlobalTypes.CLEAR_REDIRECT:
            return { ...state, redirect: null }
        case AppTypes.TOGGLE_IFRAME:
            return { ...state, showIframe: !state.showIframe };
        case GlobalTypes.SET_CHANGING_STATE:
            return { ...state, changingState: action.payload.stateName };
        case CallTypes.INCOMING_CALL:
            return { ...state, softphoneError: null };
        case GlobalTypes.NUMBER_DIALLING:
            return {...state, numberDialling: action.payload}
        case CallTypes.CALL_ENDED:
            return {...state, numberDialling:''}
        case UserTypes.LOGOUT:
            return { ...defaultState, saIsAlreadyOpen: state.saIsAlreadyOpen };
        case GlobalTypes.SET_SA_IS_ALREADY_OPEN:
            return { ...state, saIsAlreadyOpen: action.payload};
        default:
            return state;
    }
}
